export const PIPEDRIVE_TO_MAILCHIMP_LIST = 'PIPEDRIVE_TO_MAILCHIMP_LIST';
export const MAILCHIMP_TO_PIPEDRIVE_LIST = 'MAILCHIMP_TO_PIPEDRIVE_LIST';
export const MAILCHIMP_TO_COPPER_LIST = 'MAILCHIMP_TO_COPPER_LIST';
export const COPPER_TO_MAILCHIMP_LIST = 'COPPER_TO_MAILCHIMP_LIST';
export const MAILCHIMP_TO_HUBSPOT_LIST = 'MAILCHIMP_TO_HUBSPOT_LIST';
export const LEAD_SCORING_SETTINGS = 'LEAD_SCORING_SETTINGS';
export const WEB_TRACKING_SETTINGS = 'WEB_TRACKING_SETTINGS';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const RESET = 'RESET';
